import React from 'react';

import {ITotalProducts} from './ITotalProducts';

import styles from './TotalProducts.module.scss';

const TotalProducts = ({total}: ITotalProducts) => {
	if (!total) {
		return null;
	}

	return (
		<span className={styles['total-products-number']}>
			{total}
		</span>
	);
};

export default TotalProducts;
